import {
  LOGIN,
  LOGOUT,
  START_AUTHENTICATION,
  STOP_AUTHENTICATION,
  ERROR,
} from '../constants/actionTypes';

import authStorage from '../../functions/authStorage';
import defaultAuthState from '../../constants/defaultAuthState';

const authReducer = (state, action) => {
  switch (action.type) {
    case LOGIN: {
      const { authResponse } = action;
      authStorage.set(authResponse);
      return {
        ...state,
        authResponse,
      };
    }
    case LOGOUT:
      authStorage.remove();

      return {
        ...state,
        ...defaultAuthState,
      };
    case START_AUTHENTICATION:
      return {
        ...state,
        isAuthenticating: true,
      };
    case STOP_AUTHENTICATION:
      return {
        ...state,
        isAuthenticating: false,
      };
    case ERROR: {
      const { errorType, error } = action;
      return {
        ...state,
        ...defaultAuthState,
        errorType,
        error,
      };
    }
    default:
      return state;
  }
};

export default authReducer;
